var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{class:_vm.wrapClasses,style:(_vm.wrapStyle)},[_c('span',{staticClass:"ant-tag-text"},[_vm._t("default")],2),_vm._v(" "),(_vm.closable)?_c('i',{staticClass:"anticon anticon-cross",on:{"click":_vm.remove}}):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6c0ddbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/tag/tag.vue
// module id = null
// module chunks = 